<app-admin-menu></app-admin-menu>

<h1 class="mat-headline-3">Attestera arbetad tid</h1>

<div class="container-fluid">
    <div class="row">
        <div class="col">
            <app-attest-time (filterChanged)="updateQueryParameters($event)" [day]="day" [page]="page"></app-attest-time>
        </div>
    </div>
</div>

<app-messages #messagesPartial [employeeId]="employeeId"></app-messages>

<app-admin-footer></app-admin-footer>
